import {MicaProductParams} from '../../types/interfaces/configuration';

export class FetchMicaProductParamsList {
  static readonly type = '[ListMicaProductParams] Fetch All';

  constructor(public payload: MicaProductParams) {
  }
}
